import { InternalAccessor, TableColumn, TableHoverActions, Text } from '@billy/design-system'
import { TFunction } from 'i18next'
import { useMemo } from 'react'

import type { ProductUnitTableItem } from '../types/productUnitTableItem'

interface UseProductUnitsListTableColumnsOptions {
  handleRowDeleteActionClick: (id: string) => () => void
  t: TFunction
}

export const useProductUnitsListTableColumns = ({
  handleRowDeleteActionClick,
  t,
}: UseProductUnitsListTableColumnsOptions): TableColumn<ProductUnitTableItem>[] => {
  return useMemo(
    () => [
      {
        accessor: 'unit',
        Header: t('products.product_units_modal.table.column.unit'),
        truncate: true,
        Cell: ({ row: { original } }) =>
          original[InternalAccessor.SectionHeader] ? (
            <Text colorVariant="discreet" weight="medium">
              {original.unit}
            </Text>
          ) : (
            original.unit
          ),
      },
      {
        accessor: 'fullName',
        alignment: 'right',
        Header: '',
        size: 'xs',
        Cell: ({ row: { original } }) =>
          original.fullName ? <Text colorVariant="discreet">{original.fullName}</Text> : null,
      },
      {
        accessor: InternalAccessor.HoverActions,
        Header: '',
        Cell: ({ row: { original } }) => (
          <TableHoverActions>
            <TableHoverActions.Item
              icon="trash"
              label={t('products.product_units_modal.table.actions.delete')}
              onClick={handleRowDeleteActionClick(original.id)}
            />
          </TableHoverActions>
        ),
      },
    ],
    [t, handleRowDeleteActionClick],
  )
}
